import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { getComment, getCommentById, addComment, updateComment, deleteComment } from '../../helpers/';
import { getCommentResponseSuccess, getCommentResponseError } from './actions';
import { CommentActionTypes } from './constants';

/**
 * Get Comment
 * @param {*} payload
 * @query
 * 
 */

function* comment({ payload }) {
  try {
    const response = yield call(getComment, payload.params);
    yield put(getCommentResponseSuccess(CommentActionTypes.GET_COMMENT, response.data));
  } catch(error) {
    yield put(getCommentResponseError(CommentActionTypes.GET_COMMENT, error));
  }
};

function* commentById({ payload }) {
  try {
    const response = yield call(getCommentById, payload.params);
    yield put(getCommentResponseSuccess(CommentActionTypes.GET_COMMENT_BY_ID, response.data));
  } catch(error) {
    yield put(getCommentResponseError(CommentActionTypes.GET_COMMENT_BY_ID, error));
  }
};

function* addedComment({ payload }) {
  try {
    const response = yield call(addComment, payload);
    yield put(getCommentResponseSuccess(CommentActionTypes.ADD_COMMENT, response.data));
  } catch(error) {
    yield put(getCommentResponseError(CommentActionTypes.ADD_COMMENT, error));
  }
};

function* updatedComment({ payload }) {
  try {
    const response = yield call(updateComment, payload);
    yield put(getCommentResponseSuccess(CommentActionTypes.UPDATE_COMMENT, response.data));
  } catch(error) {
    yield put(getCommentResponseError(CommentActionTypes.UPDATE_COMMENT, error));
  }
};

function* deletedComment({ payload }) {
  try {
    const response = yield call(deleteComment, payload);
    yield put(getCommentResponseSuccess(CommentActionTypes.DELETE_COMMENT, response.data));
  } catch(error) {
    yield put(getCommentResponseError(CommentActionTypes.DELETE_COMMENT, error));
  }
};

export function* watchComment() {
  yield takeEvery(CommentActionTypes.GET_COMMENT, comment);
};

export function* watchCommentById() {
  yield takeEvery(CommentActionTypes.GET_COMMENT_BY_ID, commentById)
};

export function* watchAddComment() {
  yield takeEvery(CommentActionTypes.ADD_COMMENT, addedComment);
};

export function* watchUpdateComment() {
  yield takeEvery(CommentActionTypes.UPDATE_COMMENT, updatedComment);
};

export function* watchDeleteComment() {
  yield takeEvery(CommentActionTypes.DELETE_COMMENT, deletedComment);
};

function* commentSaga() {
  yield all([
    fork(watchComment),
    fork(watchCommentById),
    fork(watchAddComment),
    fork(watchUpdateComment),
    fork(watchDeleteComment),
  ])
};

export default commentSaga;